export default "__VITE_ASSET__BlsV1yah__"